import { store as auth } from '@/modules/auth'
import { store as menu } from '@/modules/menu'

export default {
  auth,
  menu
}
